module.exports = __webpack_public_path__ + "img/Delivery time Icon - white.9fdb10c8.svg";